/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseInputMixin as BaseInputMixin } from 'mixins';

const __vue_script__ = {
  name: "InputBase",
  props: ['state'],
  ...BaseInputMixin
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.visible)?_c('div',{staticClass:"form-group"},[(undefined === _vm.state.showlabel || _vm.state.showlabel)?[_vm._t("label",function(){return [_c('label',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticClass:"control-label",attrs:{"for":_vm.state.name}},[(_vm.state.i18nLabel)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.state.label),expression:"state.label"}]}):_c('span',[_vm._v(_vm._s(_vm.state.label))]),_vm._v(" "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showhelpicon)?_c('i',{staticClass:"skin-color",class:_vm.g3wtemplate.font['info'],staticStyle:{"margin-left":"3px","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.showHideHelp.apply(null, arguments)}}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_vm._t("label-action"),_vm._v(" "),(_vm.state.relationField)?_c('div',{staticStyle:{"color":"var(--skin-warning)","padding":"3px 0 3px 15px"}},[_c('span',{class:_vm.g3wtemplate.getFontClass('warning')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('Relation key field'),expression:"'Relation key field'"}]})]):_vm._e(),_vm._v(" "),_c('div',{},[_vm._t("loading",function(){return [(_vm.loadingState === 'loading')?_c('div',{staticStyle:{"position":"relative","width":"100%"},attrs:{"slot":"loading"},slot:"loading"},[_c('bar-loader',{attrs:{"loading":true}})],1):_vm._e()]}),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("message",function(){return [(_vm.notvalid)?_c('p',{staticClass:"g3w-long-text error-input-message",staticStyle:{"margin":"0"},domProps:{"innerHTML":_vm._s(_vm.state.validate.message)}}):(_vm.state.info)?_c('p',{staticStyle:{"margin":"0"},domProps:{"innerHTML":_vm._s(_vm.state.info)}}):_vm._e()]}),_vm._v(" "),(_vm.state.help && this.state.help.visible)?_c('div',{staticClass:"g3w_input_help skin-background-color",staticStyle:{"background-color":"hsl(from var(--skin-color) h s calc(l + 48)) !important"},domProps:{"innerHTML":_vm._s(_vm.state.help.message)}}):_vm._e()],2)],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-61356f4f_0", { source: ".control-label[data-v-61356f4f]{text-align:left!important;padding-top:0!important;margin-bottom:3px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-61356f4f"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputBase.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__